import React from 'react';
import './Chat.css'
import ChatList from "../ChatList/ChatList";
import Messages from "../Messenges/Messages";

const Chat = () => {
    return (
        <div className="chat__block">
            <ChatList/>
            <Messages/>
        </div>
    );
};

export default Chat;